<template>
<!--侧边导航-->
  <div class="outBox">
    <router-link to="/tasks">
      <div class="innerImg">
        <img src="../assets/image/logo.png" alt="">
      </div>
    </router-link>
    <div class="addNew" @click="addNewTasks" v-if="false">+ NEW</div>
    <div class="menuList">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo changeHover"
        background-color="#1F2D42"
        text-color="#fff"
        v-for="(item,indexs) in menuList" :key="indexs"
        active-text-color="#fff"
        @select="changeItem"
      >
        <el-menu-item :index="item.path"  :class="activeMenu == item.path ? 'orange':''">
                    <img :src="item.icon" alt="">
          <span slot="title">
            {{item.name}}
           <div class="pop" v-if="item.name == 'Pre-tasks' && preNum && preNum<= 99"  :class="activeMenu == item.path ? 'changePop':''">{{preNum}}</div>
           <div class="pop" v-if="item.name == 'Pre-tasks' && preNum>99"  :class="activeMenu == item.path ? 'changePop':''">99+</div>
           <div class="pop" v-if="item.name == 'Dispatch' && dispatch_num && dispatch_num<= 99"  :class="activeMenu == item.path ? 'changePop':''">{{dispatch_num}}</div>
           <div class="pop" v-if="item.name == 'Dispatch' && dispatch_num>99"  :class="activeMenu == item.path ? 'changePop':''">99+</div>
          </span>
        </el-menu-item>
      </el-menu>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :title="title"
      :visible.sync="addNewTaskDiog"
      @close="clearDialog"
     >
      <div class="outSelect" v-if="showSelect">
        <div style="width: 1px;height: 20px ;background: #E0E0E0;margin-left: 24px;transform: translateY(6px)"></div>
        <div class="rightSelete">
          <div class="leftSelect ">
            <div class="innerLeft">
              <el-dropdown @command="changeStore" @visible-change="oneArrow = !oneArrow" trigger="click" placement="bottom-start">
        <span class="el-dropdown-link">
          <span style="margin-right: 3px;color: #000000">{{value1}}</span>
          <i class="el-icon-arrow-down el-icon--right" v-if="!oneArrow"></i>
          <i class="el-icon-arrow-up el-icon--right" v-if="oneArrow"></i>
        </span>
                <el-dropdown-menu slot="dropdown" class="changePosition">
                  <el-dropdown-item
                    v-for="item in options1"
                    :key="item.organization_id"
                    :command="item">
                    {{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-dropdown @command="changeStore2"  @visible-change="twoArrow = !twoArrow" trigger="click"  placement="bottom-start">
              <span class="el-dropdown-link">
                <span style="margin-right: 3px;color: #000000" v-if="value2!= ''">{{value2}}</span>
                <span style="margin-right: 3px;color: #CCCCCC" v-else>Select</span>
                <i class="el-icon-arrow-down el-icon--right" v-if="!twoArrow"></i>
                <i class="el-icon-arrow-up el-icon--right" v-if="twoArrow"></i>
              </span>
                <el-dropdown-menu slot="dropdown" class="changePosition" v-if="value2!= ''">
                  <el-dropdown-item
                    v-for="item in options2"
                    :key="item.organization_id"
                    :command="item"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" class="changePosition" v-else>
                  <el-dropdown-item disabled>no data</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <add-new-tasks v-if="addNewTaskDiog" ref="createTasks" :title="title"  @closeDialog="addNewTaskDiog = false;$forceUpdate()"></add-new-tasks>
    </el-dialog>
  </div>
</template>

<script>
import addNewTasks from "@/components/addNewTasks";
import {getOrgaList, getSubOrgaList} from "@/api/addressBook";
import startWs from '@/ws/ws'
import EventBus from "@/ws/eventBus";
import listen from "@/listenScanCode/listenScan";
import {helpers} from "gmap-vue";
const {googleMapsApiInitializer} = helpers;
export default {
  components:{
   addNewTasks
  },
  data(){
    return{
      oneArrow:false,
      twoArrow:false,
      menuList:[],
      activeMenu:'/tasks',
      addNewTaskDiog:false,
      title:'Create a New Task',
      showSelect:false,
      options1:[],
      options2:[],
      value1:"",
      value2:"",
      preNum:'',
      dispatch_num:'',
    }
  },
  created() {
    this.activeMenu = this.$route.path
    this.getMenuList()
    //连接ws
   this.getPreNum()
    //获取地图联想
    googleMapsApiInitializer({
      key: 'AIzaSyCPQ7yyCSARlX-6J1WVfPl_0Q-NR65tAYs',
      //AIzaSyDKiBS6ryd_f3NFp0XadaRd6mfRm7pD1bc(司机地图)  AIzaSyCPQ7yyCSARlX-6J1WVfPl_0Q-NR65tAYs
      libraries: 'places',
    }, );
    EventBus.$on('unassignedCount',(a)=>{
      this.dispatch_num = a
    })
  },
  mounted() {
   listen.listenScanCodeGun()
    EventBus.$on('bubble',(count)=>{
      this.preNum = count
    })
  },
  methods:{
    getPreNum(){
      // let ws_flage = JSON.parse(localStorage.getItem('start_flage'))
      // // eslint-disable-next-line no-debugger
      // console.log(ws_flage,'start_flage')
      // if (ws_flage) return;
      // startWs.startWs();
    },
    //根据账号显示菜单
    getMenuList(){
      const userInfo = localStorage.getItem('userInfo')
      let admin
     //是否为首店 用来显示 orga 以及bill
      if (userInfo) {
        admin = JSON.parse(userInfo).type
       var is_first = JSON.parse(userInfo).is_first
      }

      if (admin == 0){
        this.menuList = [
          {name:"Tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/tasks'},
          // {name:"Pre-tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/preTask'},
          {name:"Drivers' Map",icon:require('../assets/image/Dashboard@2x(1).png'),path: '/dirverMap'},
          {name:"Address Book",icon:require('../assets/image/Dashboard@2x(2).png'),path: '/addressBook'},
          {name:"Organizations",icon:require('../assets/image/Organization@2x.png'),path:'/organizations'},
          {name:"Drivers",icon:require('../assets/image/drivers@2x.png'),path:'/driver'},
          // {name:"Analyze",icon:require('../assets/image/analyze.png'),path:'/analyze'},
          {name:"Analysis",icon:require('../assets/image/analyze.png'),path:'/analyze'},
          {name:"Rules",icon:require('../assets/image/rules.png'),path:'/assigRules'},
          {name:"Dispatch",icon:require('../assets/image/dispatch (1).png'),path:'/Dispatch'},
          {name:"Administrator",icon:require('../assets/image/administrator@2x.png'),path:'/Administrator'},
          {name:"FailureReview",icon:require('../assets/image/faildrivers@2x.png'),path:'/FailureReview'},
          {name:"WageReview",icon:require('../assets/image/wage.png'),path:'/WageReview'},
          {name:"Billing",icon:require('../assets/billing/invoices@2x(2).png'),path:'/billing'},
          // {name:"pay_test",icon:require('../assets/billing/invoices@2x(2).png'),path:'/pay_test'},
        ]
      }else if (admin == 2) {
        this.menuList = [
          {name:"Tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/tasks'},
          {name:"Address Book",icon:require('../assets/image/Dashboard@2x(2).png'),path: '/addressBook'},
          {name:"Dispatch",icon:require('../assets/image/dispatch (1).png'),path:'/Dispatch'},
        ]
      } else {
        if  (is_first == 1){
          this.menuList = [
            {name:"Tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/tasks'},
            // {name:"Pre-tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/preTask'},
            {name:"Drivers' Map",icon:require('../assets/image/Dashboard@2x(1).png'),path: '/dirverMap'},
            {name:"Address Book",icon:require('../assets/image/Dashboard@2x(2).png'),path: '/addressBook'},
            {name:"Organizations",icon:require('../assets/image/Organization@2x.png'),path:'/organizations'},
            {name:"Broadcast",icon:require('../assets/image/broadcast@2x.png'),path:'/broadcast'},
            {name:"Analysis",icon:require('../assets/image/analyze.png'),path:'/analyze'},
            {name:"Billing",icon:require('../assets/billing/invoices@2x(2).png'),path:'/billing'},
          ]
        }else {
          this.menuList = [
            {name:"Tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/tasks'},
            // {name:"Pre-tasks",icon:require('../assets/image/Dashboard@2x.png'),path:'/preTask'},
            {name:"Drivers' Map",icon:require('../assets/image/Dashboard@2x(1).png'),path: '/dirverMap'},
            {name:"Address Book",icon:require('../assets/image/Dashboard@2x(2).png'),path: '/addressBook'},
            {name:"Broadcast",icon:require('../assets/image/broadcast@2x.png'),path:'/broadcast'},
            {name:"Analysis",icon:require('../assets/image/analyze.png'),path:'/analyze'},
          ]
        }
      }
      if (admin == 0 || admin == 2){
        this.showSelect = true
        this.gettopState()
      }
    },
    //改变第一个值
    changeStore(val){
      this.value1 = val.name
      this.organization_id = val.organization_id
      this.getSubData()
    },
    //改变第二个值
    changeStore2(val){
        this.value2 =val.name
        this.$store.commit('changeStore',val.sub_organization_id)
    },
    //获取组织下拉数据
    gettopState(){
      getOrgaList().then(res=>{
        this.options1 = res.data
        this.value1 = res.data[0].name
        this.changeValue1 = res.data[0].name
        this.organization_id = res.data[0].organization_id
        // this.value1.label = res.data[0].name
        this.getSubData()
      })
    },
    getSubData(){
      //获取门店下拉数据
      getSubOrgaList({
        organization_id:this.organization_id
      }).then(res=>{
        this.options2 = res.data
        if (res.data.length !=0){
          this.changeValue2 = res.data[0].name
          this.value2 = res.data[0].name
          this.$store.commit('changeStore',res.data[0].sub_organization_id)
        }else {
          this.value2 = ''
          this.$store.commit('changeStore','')
        }
      })
    },

    clearDialog(){
      this.$refs.createTasks.cancelAdd()
    },
    changeItem(index){
        this.activeMenu = index
        this.$router.push(index)
      // }
    },
    addNewTasks(){
     this.addNewTaskDiog = true
    },
  },
  watch: {
    '$route': {
      handler(to) {
        const path = this.menuList.find(item => item.path === to.path)?.path
        if (path) {
          this.activeMenu = path
        }
      },
      deep: true
    }
  },
  destroyed() {
    EventBus.$off('unassignedCount')
  }
}
</script>

<style scoped lang="less">
.changePosition{
  margin-top: 0px!important;
}
.outSelect{
  display: flex;
  position: absolute;
  top: 35px;
  left: 180px;
  .rightSelete{
    display: flex;
  }
  .leftSelect{
    display: flex;
    line-height: 32px;
    margin-left: 24px;
    font-weight: bold;
    div{
      cursor: pointer;
    }
    .innerLeft{
      margin-right: 16px;
    }
  }

}
.outBox{
  padding: 24px 16px;
  color: #FFFFFF;
  /deep/ .el-dialog__header{
    padding: 32px 32px 0px 32px;
  }
  .innerImg{
    cursor: pointer;
    img{
      width: 68px;
    }
  }
  .addNew{
    width: 168px;
    height: 32px;
    font-size: 14px;
    border-radius: 16px;
    border: 1px solid #FFFFFF;
    line-height: 32px;
    margin: 24px 0 20px;
    cursor: pointer;
  }
  .addNew:hover{
    width: 168px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 16px;
    line-height: 32px;
    margin: 24px 0 20px;
    cursor: pointer;
    color: #1F2D42;
  }
  .menuList{
    font-size: 14px;
    font-weight: bold;
    .pop{
      display: inline-block;
      background-color: #FFFFFF;
      width: 28px;
      height: 28px;
      line-height: 29px;
      text-align: center;
      border-radius: 50%;
      color: #1F2D42;
      margin-left: 12px;
      transform: translateY(-3px);
    }
    ul{
      text-align: left;
      li{
        text-align: left;
        cursor: pointer;
        margin: 10px 0;
        img{
          width: 24px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
  }
  .el-menu-item{
    height: 40px;
    line-height: 40px;
  }
  .el-menu-item:hover{
    background-color: #E95646!important;
    border-radius: 8px;
  }
  li.el-menu-item {
    border-radius: 8px;
  }
  .orange{
    background-color: #E95646!important;
    border-radius: 8px;
  }
.changePop{
  color: #E95646!important;
}
  .changes{
    border-radius: 16px;
    border: 1px solid #FFFFFF;
    background: #1F2D42;
  }
  .changes:hover{
    color: #1F2D42;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #FFFFFF;
  }
}
</style>
